import { Plus, X } from "lucide-react";
import { useLang } from "@/lib/adminLang";
import { miniInput } from "./budsjettUtils";

/* Editable list of {month, pct} — used for payment plans and the sales curve. */
export const PlanEditor = ({ plan, onChange, testid }) => {
  const { t } = useLang();
  const rows = plan || [];
  const sum = rows.reduce((a, p) => a + (Number(p.pct) || 0), 0);
  const set = (i, field, v) => {
    const ny = rows.map((p, j) => (j === i ? { ...p, [field]: field === "pct" ? Number(v) : v } : p));
    onChange(ny);
  };
  return (
    <div data-testid={testid}>
      {rows.map((p, i) => (
        <div key={i} className="flex items-center gap-2 mb-1.5">
          <input
            type="month"
            value={p.month || ""}
            onChange={(e) => set(i, "month", e.target.value)}
            className="text-[12.5px] border border-[#DED9CD] rounded-lg px-2 py-1 bg-white focus:outline-none focus:border-neutral-900"
          />
          <input
            type="number"
            value={p.pct ?? ""}
            onChange={(e) => set(i, "pct", e.target.value)}
            className={miniInput}
            min={0}
            max={100}
          />
          <span className="text-[11px] text-neutral-400">%</span>
          <button
            type="button"
            onClick={() => onChange(rows.filter((_, j) => j !== i))}
            className="text-neutral-300 hover:text-red-500 transition-colors"
          >
            <X size={13} />
          </button>
        </div>
      ))}
      <div className="flex items-center gap-3 mt-1">
        <button
          type="button"
          onClick={() => onChange([...rows, { month: "", pct: 0 }])}
          className="inline-flex items-center gap-1 text-[11.5px] text-neutral-500 hover:text-neutral-900 transition-colors"
        >
          <Plus size={12} /> {t("Add month")}
        </button>
        {rows.length > 0 && (
          <span className={`text-[11px] tabular-nums ${Math.round(sum) === 100 ? "text-emerald-600" : "text-amber-600"}`}>
            {t("Sum")} {Math.round(sum)}%
          </span>
        )}
      </div>
    </div>
  );
};
